import { render, staticRenderFns } from "./VideoDetail.vue?vue&type=template&id=60be17f4&scoped=true"
import script from "./VideoDetail.vue?vue&type=script&lang=js"
export * from "./VideoDetail.vue?vue&type=script&lang=js"
import style0 from "./VideoDetail.vue?vue&type=style&index=0&id=60be17f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60be17f4",
  null
  
)

export default component.exports